'use client';

import { c as _c } from "react/compiler-runtime";
import { TagInput } from '../../components';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { TagInputProps } from '../../components';
import type { BaseFieldProps } from './types';

/** TagInput props minus the ones RHF drives (value/onChange) and the field-level helper text. */
export type TagInputComponentProps = Omit<TagInputProps, 'value' | 'onChange' | 'helperText'>;
export interface TagInputFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: TagInputComponentProps;
}
export function TagInputField(t0) {
  const $ = _c(24);
  const {
    field,
    fieldState,
    fieldConfig,
    componentProps,
    labelSize
  } = t0;
  let componentDisabled;
  let id;
  let restComponentProps;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      ...restComponentProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = id;
    $[3] = restComponentProps;
  } else {
    componentDisabled = $[1];
    id = $[2];
    restComponentProps = $[3];
  }
  let t1;
  if ($[4] !== fieldConfig || $[5] !== fieldState || $[6] !== id) {
    t1 = getFieldIds(fieldConfig, fieldState, id);
    $[4] = fieldConfig;
    $[5] = fieldState;
    $[6] = id;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const ids = t1;
  const t2 = field.disabled || componentDisabled;
  let t3;
  if ($[8] !== field.value) {
    t3 = field.value as string[] | undefined ?? [];
    $[8] = field.value;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== field.onChange || $[11] !== ids.describedBy || $[12] !== ids.fieldId || $[13] !== ids.isInvalid || $[14] !== restComponentProps || $[15] !== t2 || $[16] !== t3) {
    t4 = <TagInput {...restComponentProps} aria-describedby={ids.describedBy} aria-invalid={ids.isInvalid} disabled={t2} id={ids.fieldId} onChange={field.onChange} value={t3} />;
    $[10] = field.onChange;
    $[11] = ids.describedBy;
    $[12] = ids.fieldId;
    $[13] = ids.isInvalid;
    $[14] = restComponentProps;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== fieldConfig || $[19] !== fieldState || $[20] !== ids || $[21] !== labelSize || $[22] !== t4) {
    t5 = <FieldShell className="flex flex-col gap-1.5" fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t4}</FieldShell>;
    $[18] = fieldConfig;
    $[19] = fieldState;
    $[20] = ids;
    $[21] = labelSize;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
}